<template>
  <svg
    width="48"
    height="48"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.7746 4.189L15.531 2L13.2875 4.189C12.2977 5.15467 12.2977 6.72033 13.2875 7.686L15.531 9.875L17.7746 7.686C18.7644 6.72033 18.7644 5.15467 17.7746 4.189ZM15.531 12.5L20.912 7.25C22.3979 8.69975 22.3979 11.0503 20.912 12.5L15.531 17.75L10.1501 12.5C8.66422 11.0503 8.66422 8.69975 10.1501 7.25L15.531 12.5ZM15.531 20.375L24.9477 11.1875C26.4336 12.6372 26.4336 14.9878 24.9477 16.4375L15.531 25.625V30H14.709C13.3093 30 12.1746 28.8929 12.1746 27.5272V22.3502L6.11443 16.4375C4.62852 14.9878 4.62852 12.6372 6.11443 11.1875L15.531 20.375Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'IconsLife'
})

defineProps({
  fill: {
    type: String,
    default: '#0AC16A'
  }
})
</script>
